// 智慧消息 ———— 消息模板
const messageTemplateJurisdiction = [
  { id: "006001001", label: "同步", children: [] },
  { id: "006001002", label: "删除", children: [] },
  { id: "006001003", label: "发送", children: [] }
];

// 智慧消息 ———— 消息推送配置
const messagePushJurisdiction = [
  { id: "006002001", label: "配置", children: [] },
  { id: "006002002", label: "重置", children: [] }
];

// 智慧消息
const messageServiceJurisdictionChildren = [
  {
    id: "006001000",
    label: "消息模板",
    routerName: "message-template-manage",
    children: messageTemplateJurisdiction
  },
  {
    id: "006002000",
    label: "消息推送配置",
    routerName: "message-push-config",
    children: messagePushJurisdiction
  },
  {
    id: "006003000",
    label: "消息推送记录",
    routerName: "message-sed-manage",
    children: []
  },
  {
    id: "006004000",
    label: "操作日志",
    routerName: "message-log",
    children: []
  }
];

const messageServiceJurisdiction = {
  id: "006",
  label: "智慧消息",
  children: messageServiceJurisdictionChildren
};

export { messageServiceJurisdiction };



// WEBPACK FOOTER //
// ./src/utils/jurisdiction/messageServiceJurisdiction.js